import {CheckoutModel} from '../models/checkout/Checkout.model';
import {ItemTypePreset} from '../models/checkout/ItemType.model';

export const hasGiftCardItem = (checkout: CheckoutModel): boolean => checkout.itemTypes.has(ItemTypePreset.GIFT_CARD);
